import { TThunkAction } from '../../types/redux';
import { IGetValuationFormUrlProps } from './types';
import { stringify } from 'qs';

import { navigateToPage } from '../../utils/navigateToPage';
import { trackClickNext } from './tracking';

export const openDataPaymentForm = (): TThunkAction => {
  return (dispatch, getState) => {
    const { page, filters } = getState();

    const formParams: IGetValuationFormUrlProps = {
      address: filters.address,
      houseId: filters.houseId,
      roomsCount: filters.roomsCount,
      totalArea: filters.area,
    };
    const queryString = stringify(formParams, { skipNulls: true });

    trackClickNext({
      page,
      queryString,
      address: filters.address,
      area: filters.area,
      roomsCount: filters.roomsCount,
    });

    navigateToPage(`/valuation-form/?${queryString}`);
  };
};
